import * as React from "react";
import { Quest } from "@/types/quests";
import QuestCard from "./quest-card";

interface QuestListProps {
  quests: Quest[];
  isLoading?: boolean;
}

export default function QuestList({
  quests,
  isLoading = false,
}: QuestListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="text-gray-400">Loading quests...</div>
      </div>
    );
  }

  if (quests.length === 0) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="text-gray-400">No quests available</div>
      </div>
    );
  }

  return (
    <div className="px-3 grid grid-cols-1 gap-8 w-full">
      {quests
        .sort((a, b) => {
          const isCompletelyMissedA =
            !!a.date_end &&
            !a.completed_by_user &&
            new Date(a.date_end).getTime() < Date.now();

          const isCompletelyMissedB =
            !!b.date_end &&
            !b.completed_by_user &&
            new Date(b.date_end).getTime() < Date.now();

          return Number(isCompletelyMissedA) - Number(isCompletelyMissedB);
        })
        .map(quest => (
          <QuestCard key={quest.id} quest={quest} />
        ))}
    </div>
  );
}
